/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Sign_Password_MismatchInputs */

const en_common_sign_password_mismatch = /** @type {(inputs: Common_Sign_Password_MismatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passwords do not match`)
};

const zh_common_sign_password_mismatch = /** @type {(inputs: Common_Sign_Password_MismatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`两次输入的密码不一致`)
};

/**
* | output |
* | --- |
* | "Passwords do not match" |
*
* @param {Common_Sign_Password_MismatchInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_sign_password_mismatch = /** @type {((inputs?: Common_Sign_Password_MismatchInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Sign_Password_MismatchInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_sign_password_mismatch(inputs)
	return zh_common_sign_password_mismatch(inputs)
});
export { common_sign_password_mismatch as "common.sign.password_mismatch" }